import { sendRequestFileStorage } from "../axios";
import Swal from "sweetalert2";

export default {
  state: {
    docs: [],
    archiveDocs: [],
  },
  mutations: {
    SET_DOCS(state, payload) {
      state.docs = payload;
    },
    SET_ARCHIVE_DOCS(state, payload) {
      state.archiveDocs = payload;
    },
  },
  actions: {
    async fileToStorage({ commit }, FD) {
      commit("SET_PROCESSING", true);
      try {
        return await sendRequestFileStorage("/", "post", FD, {
          "Content-Type": "multipart/form-data",
        });
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async getAllDocs({ commit }, CompanyINN) {
      commit("SET_PROCESSING", true);
      try {
        const { data } = await sendRequestFileStorage(`${CompanyINN}`, "get");
        commit(
          "SET_DOCS",
          data.filter((item) => !item.removed)
        );
        commit(
          "SET_ARCHIVE_DOCS",
          data.filter((item) => item.removed)
        );
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async getFile({ commit }, item) {
      commit("SET_PROCESSING", true);
      try {
        const res = await sendRequestFileStorage(`file/${item._id}`, "get",undefined,undefined,undefined,'blob');
        if(res.status === 404){
          Swal.fire({
            icon: "warning",
            title: "Вы слишком торопитесь!",
            text: `Сервер еще обрабатывает ваш документ, подождите минуточку...`
          });
          return
        }
        let reader = new FileReader();
        reader.readAsDataURL(res.data)
        reader.onload = (eventBus)=>{
          const a = document.createElement("a");
          a.href = reader.result
          a.download = item.realName;
          a.target='_blank'
          a.click();
        }
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async deleteFile({ dispatch, commit }, id) {
      commit("SET_PROCESSING", true);
      try {
        const { data } = await sendRequestFileStorage(`file/${id}`, "post", {removed: true});
        if (data.removed === true) {
          await dispatch("getAllDocs", data.inn);
        }
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async deleteFilePermanently({ dispatch, commit }, id) {
      commit("SET_PROCESSING", true);
      try {
        const { data } = await sendRequestFileStorage(`file/${id}`, "delete");
        if (data) {
          await dispatch("getAllDocs", data.inn);
        }
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async restoreFile({dispatch,commit},id){
      commit("SET_PROCESSING", true);
      try {
        const { data } = await sendRequestFileStorage(`file/${id}`, "post", {removed: false});
        if (data.removed === false) {
          await dispatch("getAllDocs", data.inn);
        }
      } finally {
        commit("SET_PROCESSING", false);
      }
    },
    async editName({dispatch,commit},obj){
      commit("SET_PROCESSING", true);
      try {
        const { data } = await sendRequestFileStorage(`file/${obj._id}`, "post", obj);
        if (data) {
          await dispatch("getAllDocs", data.inn);
        }
      } finally {
        commit("SET_PROCESSING", false);
      }
    }
  },
  getters: {
    getDocs: (state) => state.docs,
    getArchiveDocs: (state) => state.archiveDocs,
  },
};
